<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 bg-color">
  <div class="col-lg-5 col-md-5 col-sm-0 col-xs-12 p0"></div>
  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 middle-row mt0 text-right float-right backBtn">
    <a (click)="navigateBack()" target="" id="backToPatEdu" data-di-id="#backToPatEdu">
      <img [src]="'../../assets/icons/'+baseSiteId+'/chevron-left.svg'" alt="" class="chevron-left continue-icon">
      Back to patient education
    </a>
  </div>
</div>
<div class="header-Container">
  <h1 class="review-title">Review Request</h1>
  <h4 class="total_units">{{getTotalUnits()}} units</h4>
</div>
<div class="row ml-0 mr-0 div-style ">
  <div class="col-md-8 div-margin empty-request text-center mt-3" *ngIf="requestedItemList?.length==0">
    {{'patientEducation.emptyRequestMsg'|cxTranslate}}
  </div>
  <div *ngIf="requestedItemList?.length>0" class="col-md-8">
    <div id="location-box">
      <section *ngIf="isLocationSelected">
        <div class="locationDetails">
          <span class="selected-loc">Ship-to location :</span>
        </div>
        <div class="locationIcon">
          <img class="locationicon-align" src="../../assets/icons/{{baseSiteId}}/location.svg" alt="location" />
        </div>
        <div class="locationDetails">
          <span class="selected-loc">{{ selectedLoc }}</span>
        </div>
      </section>
    </div>
    <div class="div-margin need-assistance d-none d-sm-none d-xs-none d-md-block d-lg-block d-xl-block"
      *ngFor="let item of requestedItemList;let i=index">
      <div class="row mr-0 ml-0">
        <div class="col-md-2 margin-style">
          <a href="javascript:void(0);">
            <img class="image-align" [src]="item.url">
          </a>
          <div class="mt-5">
            <span class="del-icon" [ngbPopover]=popSaveContent placement="top" #s3="ngbPopover" triggers="manual"
              popoverClass="savedordermini-popover" (click)="deletePopup(s3,item)">
              <img src="../../assets/icons/{{baseSiteId}}/trash.svg" alt="" />
              Delete</span>
          </div>
          <ng-template #popSaveContent>
            <p>{{'patientEducation.removeItem'|cxTranslate}}</p>
            <button type="button" class="popover-close btn btn-secondary" (click)="deletePopup(s3,null)">
              <!-- {{'addToCartItems.cancel'|cxTranslate}} -->
              {{'patientEducation.cancel'|cxTranslate}}
            </button>
            <button class="btn btn-primary" type="submit" (click)="removeProduct()">
              <!-- {{'addToCartItems.save'|cxTranslate}} -->
              {{'patientEducation.remove'|cxTranslate}}
            </button>
          </ng-template>
        </div>
        <div class="col-md-7">
          <div class="item-name">{{item.name}}</div>
          <div class="mt-2 desc-style" [innerHTML]="item.desc"></div>
          <div class="mt-2 prodcode-style">{{item.code}}</div>
        </div>
        <div class="col-md-3 units mt-4">
          <span class="unit-style">{{'Units'}}</span>
          <section class="unit-area">
            <span [ngClass]="{'disabled': ['1','0',''].includes(input.value)}" aria-hidden="true"
              id="{{'minusIcon'+item?.code}}">
              <img src="../../assets/icons/{{baseSiteId}}/less_new.svg" id="{{'unitMinus'+item?.code}}"
                [ngClass]="{'disabled-img': ['1','0',''].includes(input.value)}" alt="minus_icon"
                (click)="performQuantityComputation(2,item?.code,item?.quantityPerUnit,item?.unit,item,cardp1)">
              <img src="../../assets/icons/{{baseSiteId}}/less-disable_new.svg" id="{{'unitMinusDisable'+item?.code}}"
                alt="" [ngClass]="{'disabled-img': input.value > 1}">
            </span>

            <input type="number" class="prod-quantity text-center" value="{{item.units}}" (keyup)="performQuantityComputation(null,item?.code,
            item?.quantityPerUnit,item?.unit,item,cardp1)" #input (keydown)="validateInput($event)"
              id="{{'prodQuantity'+item?.code}}" maxlength="4" [ngbPopover]=popoverExpiry placement="top"
              #cardp1="ngbPopover" triggers="manual" popoverClass="savedordermini-popover expirysixmonths-popover"
              appNoMouseScroll [autoClose]="false" />

            <span class="pointer-style" aria-hidden="true" id="{{'plusIcon'+item?.code}}">
              <img src="../../assets/icons/{{baseSiteId}}/more.svg" id="{{'unitPlus'+item?.code}}" alt="plus_icon"
                (click)="performQuantityComputation(1,item?.code,item?.quantityPerUnit,item?.unit,item,cardp1)">
              <img class="disabled-img" src="../../assets/icons/{{baseSiteId}}/more-disable.svg"
                id="{{'unitPlusDisable'+item?.code}}" alt="">
            </span>
            <!-- <section class="dosessection" id="{{'noOfDoses'+item?.code}}">
              {{item?.calValue}} {{'Doses'}}</section> -->
            <!-- <section class="dosessection" id="{{'noOfDoses'+item?.code}}">
              {{item?.units <= (item?.maxAllowedQuantity / item?.quantityPerUnit)? item?.units * item?.quantityPerUnit : (item?.maxAllowedQuantity / item?.quantityPerUnit) * item?.quantityPerUnit}} {{'Doses'}}</section> -->
            <section class="dosessection" id="{{'noOfDoses'+item?.code}}">
              {{item?.units <= item?.maxAllowedQuantity ? item?.units * item?.quantityPerUnit : item?.maxAllowedQuantity
                * item?.quantityPerUnit}} {{item?.unit}} </section>
            </section>
            <ng-template #popoverExpiry>
              <div class="card-expiry-six-months d-flex">
                <img class="warning-icon" [src]="'../../../../assets/icons/'+baseSiteId+'/warning_red_new.png'"
                  alt="" />
                <!-- <span class="card-expiry-six-months-text">Limit {{item?.maxAllowedQuantity ? item?.maxAllowedQuantity / item?.quantityPerUnit : 10000 / item?.quantityPerUnit }} units</span> -->
                <div class="card-expiry-six-months-text">Limit {{item?.maxAllowedQuantity ? item?.maxAllowedQuantity :
                  9999 }} units</div>
              </div>
            </ng-template>
        </div>
        <!-- <div class="w-100"></div> -->
        <!-- <div class="col-md-1">
        <span class="del-icon">Delete</span>
      </div> -->
      </div>
    </div>

    <!--Mobile start-->
    <div class="div-margin need-assistance d-sm-block d-xs-block d-md-none"
      *ngFor="let item of requestedItemList;let i=index">
      <div class="row mr-0 ml-0">
        <div class="col-md-7 d-flex">
          <a href="javascript:void(0);">
            <img class="image-align" [src]="item.url">
          </a>
          <div class="col-md-7">
            <div class="item-name">{{item.name}}</div>
            <div class="mt-2 desc-style" [innerHTML]="item.desc"></div>
            <div class="mt-2 prodcode-style">{{item.code}}</div>
          </div>

        </div>
        <div class="col-md-3 units mt-4 d-flex">
          <div class="unitArea">
            <span class="unit-style">{{'Units'}}</span>
            <section class="unit-area">
              <span [ngClass]="{'disabled': ['1','0',''].includes(input.value)}" aria-hidden="true"
                id="{{'minusIcon'+item?.code}}">
                <img src="../../assets/icons/{{baseSiteId}}/less_new.svg" id="{{'unitMinus'+item?.code}}"
                  [ngClass]="{'disabled-img': ['1','0',''].includes(input.value)}" alt="minus_icon"
                  (click)="performQuantityComputation(2,item?.code,item?.quantityPerUnit,item?.unit,item,cardp1)">
                <img src="../../assets/icons/{{baseSiteId}}/less-disable_new.svg" id="{{'unitMinusDisable'+item?.code}}"
                  alt="" [ngClass]="{'disabled-img': input.value > 1}">
              </span>

              <input type="number" class="prod-quantity text-center" value="{{item.units}}" (keyup)="performQuantityComputation(null,item?.code,
              item?.quantityPerUnit,item?.unit,item,cardp1)" #input (keydown)="validateInput($event)"
                id="{{'prodQuantity'+item?.code}}" maxlength="4" [ngbPopover]=popoverExpiry placement="top"
                #cardp1="ngbPopover" triggers="manual" popoverClass="savedordermini-popover expirysixmonths-popover"
                appNoMouseScroll [autoClose]="false" />

              <span class="pointer-style" aria-hidden="true" id="{{'plusIcon'+item?.code}}">
                <img src="../../assets/icons/{{baseSiteId}}/more.svg" id="{{'unitPlus'+item?.code}}" alt="plus_icon"
                  (click)="performQuantityComputation(1,item?.code,item?.quantityPerUnit,item?.unit,item,cardp1)">
                <img class="disabled-img" src="../../assets/icons/{{baseSiteId}}/more-disable.svg"
                  id="{{'unitPlusDisable'+item?.code}}" alt="">
              </span>
              <section class="dosessection" id="{{'noOfDoses'+item?.code}}">
                {{item?.units <= item?.maxAllowedQuantity ? item?.units * item?.quantityPerUnit :
                  item?.maxAllowedQuantity * item?.quantityPerUnit}} {{item?.unit}} </section>
              </section>
              <ng-template #popoverExpiry>
                <div class="card-expiry-six-months d-flex">
                  <img class="warning-icon" [src]="'../../../../assets/icons/'+baseSiteId+'/warning_red_new.png'"
                    alt="" />
                  <div class="card-expiry-six-months-text">Limit {{item?.maxAllowedQuantity ? item?.maxAllowedQuantity :
                    9999 }} units</div>
                </div>
              </ng-template>
          </div>
          <div class="deleteIconRow mb-2">
            <span class="del-icon" [ngbPopover]=popSaveContent placement="top" #s3="ngbPopover" triggers="manual"
              popoverClass="savedordermini-popover" (click)="deletePopup(s3,item)">
              <img src="../../assets/icons/{{baseSiteId}}/trash.svg" alt="" />
              Delete</span>
          </div>
          <ng-template #popSaveContent>
            <p>{{'patientEducation.removeItem'|cxTranslate}}</p>
            <button type="button" class="popover-close btn btn-secondary" (click)="deletePopup(s3,null)">

              {{'patientEducation.cancel'|cxTranslate}}
            </button>
            <button class="btn btn-primary" type="submit" (click)="removeProduct()">

              {{'patientEducation.remove'|cxTranslate}}
            </button>
          </ng-template>

        </div>
      </div>
    </div>
    <!--Mobile end-->

  </div>
  <div class="col-md-4">
    <section class="plpbutton d-flex flex-column justify-content-center">
      <button type="button" class="btn-primary three mb-2" (click)="submitRequest()"
        [disabled]="requestedItemList?.length==0 || selectedLoc=='' || isQtyLimitExceeded">
        {{'patientEducation.submitRequest'|cxTranslate}}
      </button>
      <button type="button" class="btn-secondary three mb-2" (click)="openCancelModal(deletemodal)"
        *ngIf="requestedItemList?.length>0">
        {{'patientEducation.cancel'|cxTranslate}}
      </button>
    </section>

    <p class="need-assistance">
      {{baseSiteId=='vax'?('patientEducation.needAssistance'|cxTranslate):('patientEducation.needAssistanceVsh'|cxTranslate)}}
    </p>
    <hr>
    <section class="acc-information">
      <p>
        {{'patientEducation.information'|cxTranslate}}
      </p>
      <div class="row">
        <span class="col-md-5">{{'patientEducation.accountName'|cxTranslate}}</span>
        <span class="col-md-7">{{accountInformation?.name}}</span>
      </div>
      <div class="row">
        <span class="col-md-5">{{'patientEducation.accountNumber'|cxTranslate}}</span>
        <span class="col-md-7">{{accountInformation?.uid}}</span>
      </div>
      <div class="row">
        <span class="col-md-5">{{'patientEducation.phoneNumber'|cxTranslate}}</span>
        <span class="col-md-7">{{accountInformation?.phone}}</span>
      </div>
      <div class="row">
        <span class="col-md-5">{{'patientEducation.emailAddress'|cxTranslate}}</span>
        <span class="col-md-7">{{accountInformation?.email}}</span>
      </div>
    </section>
  </div>
</div>
<ng-template #deletemodal let-modal>
  <div class="modal-header header-style">
    <span> {{'patientEducation.cancelRequest'|cxTranslate}}</span>
  </div>
  <div class="modal-body body-style">
    <span>{{'patientEducation.cancelTitle'|cxTranslate}}</span>
  </div>
  <div>
    <section class="plpbutton d-flex flex-column justify-content-center">
      <button type="button" class="btn btn-primary mb-2" (click)="cancelRequest()">
        Yes,&nbsp;Cancel
      </button>
      <button type="button" class="btn btn-secondary mb-2" (click)="closeModal()">
        No
      </button>
    </section>

  </div>
</ng-template>